import { l } from '../lib/imports'
import { largeSprites } from '../sprites/largeSprites'

export const spriteMapSources = [
  '', // 1
  'ssp',
]

// export const backgroundImages = ['under/x/under-background']

export function preloadAssets(load: Phaser.Loader.LoaderPlugin) {
  // this.load.glsl("bundle", "assets/plasma-bundle.glsl.js");
  // this.load.glsl("stars", "assets/starfields.glsl.js");

  loadImgs(load, spriteMapSources)

  // TODO: per-project?
  // loadImgs(load, backgroundImages)

  // loadImgs(load, ['1-32'])
  // loadImgs(load, ['monsters'])
  // loadImgs(load, ['dungeon'])
  // loadImgs(load, ['ui'])
  // loadImgs(load, ['ship'])
  // loadImgs(load, ['6-15'])
  // loadImgs(load, ['7-16'])
  // loadImgs(load, ['8-8'])
  // loadImgs(load, ['9-Items'])

  loadSoundSprites(load, ['audioSprite2'])
  // loadJson(load, ['voyage'], 'assets/data')
  // loadJson(load, ['player-walk-arms-split'], 'assets/sprites/under/player')
  // loadTxt(load, ['books'], 'assets/data')
  // loadStevieFonts(load, ['oryx_32px', 'oryx_24px', 'oryx_16px'])
  loadLargeSprites(load)
}

function loadLargeSprites(load: Phaser.Loader.LoaderPlugin) {
  l.forEach(largeSprites, (c) => {
    load.image(c.k, `assets/sprites/${c.d + '/' + c.f}.png`)
  })
}

function loadImgs(load: Phaser.Loader.LoaderPlugin, names: string[]) {
  names.forEach((c) => {
    if (c) {
      load.image(c, `assets/sprites/${c}.png`)
    }
  })
}

function loadSoundSprites(load: Phaser.Loader.LoaderPlugin, names: string[]) {
  loadJson(load, names, 'assets/sounds')
}
function loadJson(
  load: Phaser.Loader.LoaderPlugin,
  names: string[],
  path: string,
) {
  names.forEach((c) => {
    load.json(c, `${path}/${c}.json`)
  })
}

// function loadTxt(
//   load: Phaser.Loader.LoaderPlugin,
//   names: string[],
//   path: string,
// ) {
//   names.forEach((c) => {
//     load.text(c, `${path}/${c}.txt`)
//   })
// }

// function loadStevieFonts(load: Phaser.Loader.LoaderPlugin, names: string[]) {
//   names.forEach((c) => {
//     load.json(c + '-font-data', `assets/fonts/${c}.json`)
//     load.image(c + '-font', `assets/fonts/${c}.png`)
//   })
// }
